module.exports = __webpack_public_path__ + "static/img/j2.c0cdb792.png";